import { render } from "./DProfile.vue?vue&type=template&id=e0e6584a&scoped=true&ts=true"
import script from "./DProfile.vue?vue&type=script&lang=ts"
export * from "./DProfile.vue?vue&type=script&lang=ts"

import "./DProfile.vue?vue&type=style&index=0&id=e0e6584a&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e6584a"]])

export default __exports__